'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = require('../constants');

var _booking = require('@arreeba/ristoranti-lib/lib/action/booking');

var _booking2 = _interopRequireDefault(_booking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, _booking2.default, {
  setUserLocation: function setUserLocation(location) {
    return {
      type: _constants.SET_USER_LOCATION,
      location: {
        lat: location.lat,
        lng: location.lng
      }
    };
  },
  setBookingRestaurant: function setBookingRestaurant(restaurant) {
    return {
      type: _constants.SET_BOOKING_RESTAURANT,
      restaurant: restaurant
    };
  },
  setBookingDate: function setBookingDate(date, hasBookingRushes, bookingRushId) {
    return {
      type: _constants.SET_BOOKING_DATE,
      hasBookingRushes: hasBookingRushes,
      bookingRushId: bookingRushId,
      date: date
    };
  },
  setBookingSeats: function setBookingSeats(n) {
    return {
      type: _constants.SET_BOOKING_SEATS,
      n: n
    };
  },
  setBookingTime: function setBookingTime(time, verifyBookingRush) {
    return {
      type: _constants.SET_BOOKING_TIME,
      time: time,
      verifyBookingRush: verifyBookingRush
    };
  },
  setFormData: function setFormData(data) {
    return {
      type: _constants.BOOKING_SET_FORM,
      data: data
    };
  },
  endBooking: function endBooking() {
    return {
      type: _constants.BOOKING_RESET_END
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/actions/booking.js
// module id = 409
// module chunks = 0